import React, { useEffect, useState } from "react";
import { FISH_FEED_OUTGOING_CALL } from "../../../constants";
import axios from "axios";
import dayjs from "dayjs";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import ConnectedCallTable from "./ConnectedCallTable";
import FilterComponent from "./FilterComponent";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterListIcon from "@mui/icons-material/FilterList";
import NotConnectedCallTable from "./NotConnectedCallTable";
import Loader from "../../reusable Component/Loader";
import * as XLSX from "xlsx";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

function AgentOutcomingReport({}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"), // 7 days ago
    endDate: dayjs().format("YYYY-MM-DD"), // Today
  });

  const [callStatistics, setCallStatistics] = useState([]);
  const [metricData, setMetricData] = useState([]);

  //   const fetchCallStatistics = () => {
  //     const { startDate, endDate } = filters;
  //     setLoading(true);

  //     // Determine yesterday's date
  //     const last7days = dayjs().subtract(6, "days").format("YYYY-MM-DD");

  //     // Format startDate and endDate, defaulting to yesterday if not provided
  //     const formattedStartDate = startDate
  //       ? dayjs(startDate).format("YYYY-MM-DD")
  //       : last7days;
  //     const formattedEndDate = endDate
  //       ? dayjs(endDate).format("YYYY-MM-DD")
  //       : dayjs().format("YYYY-MM-DD");

  //     // Build query params
  //     const queryParams = new URLSearchParams();
  //     queryParams.append("startDate", formattedStartDate);
  //     queryParams.append("endDate", formattedEndDate);
  //     queryParams.append("agentNumber", empDetails.EmployeePhone);
  //     queryParams.append("callStatus", "connected");

  //     axios
  //       .get(`${AUDIT_CALLING_DETAILS_REPORT}?${queryParams.toString()}`)
  //       .then((response) => {
  //         const { overallStats, employeeStats } = response.data;
  //         setCallStatistics(employeeStats);
  //         setMetricData(overallStats);
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //         setCallStatistics([]);
  //         setMetricData([]);
  //         setLoading(false);
  //       });
  //   };

  //   useEffect(() => {
  //     fetchCallStatistics();
  //   }, []);

  const [tabValues, setTabValues] = useState(0); // Default to the first tab

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValues(newValue); // Update the current tab index
  };

  // const handleExport = async () => {
  //   try {
  //     setLoading(true);
  //     const { startDate, endDate } = filters;

  //     const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
  //     const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

  //     const empDetails = JSON.parse(localStorage.getItem("userData"));
  //     const agentNumber =
  //       localStorage.getItem("empRole") === "300"
  //         ? empDetails?.EmployeePhone
  //         : 7880162561;

  //     const commonParams = `startDate=${formattedStartDate}&endDate=${formattedEndDate}&agentNumber=${agentNumber}&page=1&pageSize=10000`;

  //     const [connectedRes, notConnectedRes] = await Promise.all([
  //       axios.get(
  //         `${FISH_FEED_OUTGOING_CALL}?${commonParams}&callStatus=Connected`
  //       ),
  //       axios.get(
  //         `${FISH_FEED_OUTGOING_CALL}?${commonParams}&callStatus=NotConnected`
  //       ),
  //     ]);

  //     const connectedCalls = connectedRes.data?.connected?.calls || [];
  //     console.log(connectedCalls);
  //     const notConnectedCalls = notConnectedRes.data?.notConnected?.calls || [];

  //     const exportData = [...connectedCalls, ...notConnectedCalls].map(
  //       (row) => ({
  //         "Caller Number": row.customerNumber || "-",
  //         "Dealer Name": row.customerDetails?.dealerName || "-",
  //         Region: row.customerDetails?.region || "-",
  //         "Farmer Type": row.customerDetails?.farmerType || "-",
  //         "Postal Code": row.customerDetails?.postalCode || "-",
  //         Status: row.customerDetails?.status || "-",
  //         "Start Time": row.callStartTime
  //           ? dayjs(row.callStartTime).format("YYYY-MM-DD HH:mm:ss")
  //           : "-",
  //         "Call Date": row.callStartDate || "-",
  //         "Call Status": row.callStatus || "-",
  //       })
  //     );

  //     const worksheet = XLSX.utils.json_to_sheet(exportData);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Outgoing Calls");

  //     XLSX.writeFile(
  //       workbook,
  //       `outgoing_calls_${formattedStartDate}_to_${formattedEndDate}.xlsx`
  //     );
  //   } catch (err) {
  //     console.error("Failed to export outgoing calls:", err);
  //     alert("Failed to export outgoing call data.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleExport = async () => {
    try {
      setLoading(true);
      const { startDate, endDate } = filters;

      const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

      const empDetails = JSON.parse(localStorage.getItem("userData"));
      const agentNumber =
        localStorage.getItem("empRole") === "300"
          ? empDetails?.EmployeePhone
          : 7880162561;

      const commonParams = `startDate=${formattedStartDate}&endDate=${formattedEndDate}&agentNumber=${agentNumber}&page=1&pageSize=10000`;

      const [connectedRes, notConnectedRes] = await Promise.all([
        axios.get(
          `${FISH_FEED_OUTGOING_CALL}?${commonParams}&callStatus=Connected`
        ),
        axios.get(
          `${FISH_FEED_OUTGOING_CALL}?${commonParams}&callStatus=NotConnected`
        ),
      ]);

      const connectedCalls = connectedRes.data?.connected?.calls || [];
      const notConnectedCalls = notConnectedRes.data?.notConnected?.calls || [];

      // Add connection status to each call
      const connectedCallsWithStatus = connectedCalls.map((call) => ({
        ...call,
        connectionStatus: "Connected",
      }));

      const notConnectedCallsWithStatus = notConnectedCalls.map((call) => ({
        ...call,
        connectionStatus: "Not Connected",
      }));

      const allCalls = [
        ...connectedCallsWithStatus,
        ...notConnectedCallsWithStatus,
      ];

      // Create main calls sheet data
      const callsData = allCalls.map((row) => ({
        "Agent Number": row.agentNumber || "-",
        "Agent Name": row.agentDetails?.name || "-",
        "Agent Employee ID": row.agentDetails?.employeeId || "-",
        "Customer Number": row.customerNumber || "-",
        "Connection Status": row.connectionStatus || "-", // Added this line
        Region: row.customerDetails?.region || "-",
        // "Customer Source": row.customerDetails?.source || "-",
        "Farmer Village": row.customerDetails?.farmerVillage || "-",
        "Shrimp Zone": row.customerDetails?.shrimpZone || "-",
        "Dealer Name": row.customerDetails?.dealerName || "-",
        "Dealer Code": row.customerDetails?.dealerCode || "-",
        State: row.customerDetails?.state || "-",
        "Postal Code": row.customerDetails?.postalCode || "-",
        "Feed Type": row.customerDetails?.feedType || "-",
        "Employee Code": row.customerDetails?.employeeCode || "-",
        "Farmer Type": row.customerDetails?.farmerType || "-",
        "Last Action Date": row.customerDetails?.lastActionDate
          ? dayjs(row.customerDetails.lastActionDate).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "-",
        "Customer Status": row.customerDetails?.status || "-",
        // Latitude: row.customerDetails?.latitude || "-",
        // Longitude: row.customerDetails?.longitude || "-",
        Remarks: row.customerDetails?.remarks || "-",
        "Call Start Date": row.callStartDate || "-",
        "Call Start Time": row.callStartTime || "-",
        "Call Status": row.callStatus || "-",
        "Call Duration": row.callDuration || "-",
        "Disconnected By": row.disconnectedBy || "-",
        // "Recording URL": row.recordingUrl || "-",
      }));

      // Create feed remarks sheet data (flattened)
      const feedRemarksData = [];
      allCalls.forEach((call) => {
        if (
          call.customerDetails?.feedRemarks &&
          call.customerDetails.feedRemarks.length > 0
        ) {
          call.customerDetails.feedRemarks.forEach((remark) => {
            feedRemarksData.push({
              "Customer Number": call.customerNumber || "-",
              "Agent Number": call.agentNumber || "-",
              "Connection Status": call.connectionStatus || "-", // Added this line
              // "Remark ID": remark.id || "-",
              Type: remark.type || "-",
              "Prospect Farmer Category": remark.prospectFarmerCategory || "-",
              Name: remark.name || "-",
              "Mobile Number": remark.mobileNumber || "-",
              "Pond Location": remark.pondLocation || "-",
              District: remark.district || "-",
              "Postal Code": remark.postalCode || "-",
              State: remark.state || "-",
              "Fish Species": remark.fishSpecies || "-",
              "Number of Ponds": remark.numberOfPonds || "-",
              "Pond Area (Acres)": remark.pondAreaInAcres || "-",
              "Current Feed Used": remark.currentFeedUsed || "-",
              "Is Stocking": remark.isStocking || "-",
              "Stocking Density": remark.stockingDensity || "-",
              "Days of Culture": remark.daysOfCulture || "-",
              "Is Harvesting": remark.isHarvesting || "-",
              "Harvesting Quantity": remark.harvestingQuantity || "-",
              "Potentiality (MT)": remark.potentialityInMT || "-",
              Status: remark.status || "-",
              "Follow Up Date": remark.followUpDate
                ? dayjs(remark.followUpDate).format("YYYY-MM-DD")
                : "-",
              Purpose: remark.purpose || "-",
              "Agent Remarks": remark.agentRemarks || "-",
              // "Call ID": remark.callId || "-",
              "Call Type": remark.callType || "-",
              // "Created At": remark.createdAt
              //   ? dayjs(remark.createdAt).format("YYYY-MM-DD HH:mm:ss")
              //   : "-",
              // "Updated At": remark.updatedAt
              //   ? dayjs(remark.updatedAt).format("YYYY-MM-DD HH:mm:ss")
              //   : "-",
            });
          });
        }
      });

      // Create workbook with multiple sheets
      const workbook = XLSX.utils.book_new();

      // Add main calls sheet
      const callsWorksheet = XLSX.utils.json_to_sheet(callsData);
      XLSX.utils.book_append_sheet(workbook, callsWorksheet, "Outgoing Calls");

      // Add feed remarks sheet if there's data
      if (feedRemarksData.length > 0) {
        const remarksWorksheet = XLSX.utils.json_to_sheet(feedRemarksData);
        XLSX.utils.book_append_sheet(
          workbook,
          remarksWorksheet,
          "Feed Remarks"
        );
      }

      // Add summary sheet
      const summaryData = [
        { Metric: "Total Calls", Value: allCalls.length },
        { Metric: "Connected Calls", Value: connectedCalls.length },
        { Metric: "Not Connected Calls", Value: notConnectedCalls.length },
        { Metric: "Total Feed Remarks", Value: feedRemarksData.length },
        { Metric: "Export Date", Value: dayjs().format("YYYY-MM-DD HH:mm:ss") },
        {
          Metric: "Date Range",
          Value: `${formattedStartDate} to ${formattedEndDate}`,
        },
      ];
      const summaryWorksheet = XLSX.utils.json_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(workbook, summaryWorksheet, "Summary");

      // Write the file
      XLSX.writeFile(
        workbook,
        `complete_call_data_${formattedStartDate}_to_${formattedEndDate}.xlsx`
      );

      console.log(
        `Exported ${allCalls.length} calls with ${feedRemarksData.length} feed remarks`
      );
    } catch (err) {
      console.error("Failed to export call data:", err);
      alert("Failed to export call data.");
    } finally {
      setLoading(false);
    }
  };

  const [filterShow, setFilterShow] = useState(false);

  return (
    <>
      {loading && <Loader open={loading} />}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, paddingLeft: "12px", flexGrow: 1 }}
        >
          Outgoing Call Report
        </Typography>

        {/* IconButton aligned to the right */}
        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FilterListIcon />
        </IconButton>

        {/* IconButton aligned to the right */}
        <IconButton
          onClick={handleExport}
          style={{
            border: "1px solid #fff",
            borderRadius: "4px",
            margin: "5px",
            width: "40px",
            height: "40px",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73";
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <FileDownloadIcon />
        </IconButton>
      </Box>

      {filterShow && (
        <FilterComponent
          filters={filters}
          setFilters={setFilters}
          data={callStatistics}
          setFilterShow={setFilterShow}
        ></FilterComponent>
      )}

      <Box
        display="flex"
        justifyContent="space-between"
        gap="16px"
        sx={{
          padding: "16px",
          backgroundColor: "#EEF0F4",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        {/* Total Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.totalCalls || 0}
          </Typography>
        </Box>

        {/* Connected Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Connected Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.connectedCalls || 0}
          </Typography>
        </Box>

        {/* Missed Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Not-Connected Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.missedCalls || 0}
          </Typography>
        </Box>

        {/* Total Talk time */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Connected Time
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {metricData.totalDuration || 0}
          </Typography>
        </Box>
      </Box>

      <Tabs
        value={tabValues} // Current selected tab
        onChange={handleTabChange} // Handle tab change
        aria-label="Call Statistics Tabs"
      >
        {/* Tab for Connected Calls */}
        <Tab
          label={`Connected (${metricData.connectedCalls || 0})`}
          id="tab-0"
          aria-controls="tabpanel-0"
        />
        {/* Tab for Missed Calls */}
        <Tab
          label={`Not-Connected (${metricData.missedCalls || 0})`}
          id="tab-1"
          aria-controls="tabpanel-1"
        />
      </Tabs>

      {/* Tab Panels */}
      <TabPanel value={tabValues} index={0}>
        <ConnectedCallTable
          filters={filters}
          setFilters={setFilters}
          setMetricData={setMetricData}
          setLoading={setLoading}
        />
      </TabPanel>
      <TabPanel value={tabValues} index={1}>
        <NotConnectedCallTable
          filters={filters}
          setFilters={setFilters}
          setMetricData={setMetricData}
          setLoading={setLoading}
        />
      </TabPanel>
    </>
  );
}
export default AgentOutcomingReport;
